import Flickity from 'flickity';


const initGalleries = (galleries) => {

    galleries.forEach(gallery => {
        const prevButton = gallery.querySelector('.js-prev');
        const nextButton = gallery.querySelector('.js-next');    
        const carousel = gallery.querySelector('.js-gallery-items');

        const flickityOptions = {
            cellSelector: '.js-cell',
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: false,
            cellAlign: 'left',
            contain: false
        };

        const slider = new Flickity(carousel, flickityOptions); // eslint-disable-line;

        prevButton.addEventListener('click', () => {
            slider.previous();
        })

        nextButton.addEventListener('click', () => {
            slider.next();
        })

    })    
    
}

export default initGalleries;